import { getUrlAll, ThingPersisted } from '@inrupt/solid-client'
import { URI } from '../utils/ontology'

export const checkType = (thing: ThingPersisted, type: string): void => {
  const types = getUrlAll(thing, URI.TYPE_PREDICATE) || []
  if (!types.includes(type)) {
    throw new Error(
      `Given thing does not include '${type}', but has types '${types.join(
        ', '
      )}'`
    )
  }
}
